const nodeEnv = process.env.NODE_ENV;
const serverEnv = process.env.VUE_APP_SERVER;

if (!nodeEnv) {
  throw new Error('NODE_ENV is not defined');
}

class EnvService {
  static localOrDev() {
    if (serverEnv) {
      return !['production', 'test', 'prod'].includes(serverEnv)
    }
    return !['production'].includes(nodeEnv);
  }
}

export default EnvService;
